module.exports = __webpack_public_path__ + "static/media/vimeo.2f5c7a5e.svg";